import React from "react";
import "./MailUs.css";
import { useNavigate } from "react-router-dom";

const MailUs = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid mailus-bg">
        <div className="container">
          <div className="row mail-row">
            <div className="col-md-6">
              <div className="mail-content-first">
                <p className="mail-content-obtain">
                  <span style={{color:'#00436b'}}>Let’s talk</span> <br/>Bring us your goals (and your constraints). We’ll
                  meet you where you are, speak your dialect, and turn ambition
                  into Salesforce reality.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div className="mail-content-second">
                {/* <img src={mail} alt="mail-icon" />
                <p>REACH OUT NOW</p> */}
                {/* <h4>aravinthkumaran410@gmail.com</h4> */}
                <button onClick={() => navigate("/contact")}>Contact Us</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MailUs;
